import createInformesSectionPage from "./SectionPageFactory";

const InformesTesoreriaPage = createInformesSectionPage(
  "Tesorería · Panel diario",
  "Consolidado diario de rendiciones: cajas abiertas, conciliaciones por etapa y flujos proyectados."
);

export default InformesTesoreriaPage;
